import { Attr, HasOne, Model } from 'spraypaint';
import { User } from './';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class Customer extends ApplicationRecord {
  static jsonapiType = 'customers';

  static listHeaders() {
    return [
      {
        text: 'Name',
        value: 'fullName',
      },
      {
        text: 'Email address',
        value: 'email',
      },
      {
        text: 'Phone',
        value: 'phoneNumber',
      },
      {
        text: 'Has Account',
        value: 'user',
        align: 'right',
        sortable: false,
      },
      {
        text: 'Has Subscription',
        value: 'hasSubscription',
        align: 'right',
        sortable: false,
      }
    ];
  }

  static scopeFactory() {
    return Customer.includes([]);
  }

  static defaultOptions() {
    return {
      sortBy: ['pk'],
      sortDesc: [true],
    };
  }

  @Attr() email: string;
  @Attr() title: string;
  @Attr() firstName: string;
  @Attr() lastName: string;
  @Attr() phoneNumber: string;
  @Attr() business: string;
  @Attr() emailConfirmed: boolean;
  @Attr() privateNotes: string;
  @Attr() readonly hasSubscription: boolean;

  @HasOne() user: User;

  get initials() {
    return `${this.firstName.charAt(0)}${this.lastName.charAt(0)}`;
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  get customerDetails() {
    return `${this.firstName} ${this.lastName} - ${this.email} - ${this.phoneNumber}`;
  }
}
